/**
 * Editorial tags under the article body.
 *
 * They render as labels, not links. Tags used to link to
 * `/category/<tag-slug>`, but tags and categories are separate tables: the
 * category endpoint cannot resolve a tag slug, so every tag on every article
 * pointed at a URL that errors. There is no tag archive yet — until one exists
 * (API endpoint + `/tag/$slug` route + sitemap entries), the tag names still do
 * their SEO work through `keywords` in the article's NewsArticle JSON-LD, which
 * is where machines read them anyway.
 */
export function ArticleTags({ tags }: { tags: { id: string; name: string; slug: string }[] }) {
  if (tags.length === 0) return null;
  return (
    <div className="post-tags">
      <ul>
        {/* Label, not a destination. It shipped as `<a href="#">`. */}
        <li>
          <span><i className="fas fa-tag" aria-hidden="true" /> وسوم</span>
        </li>
        {tags.map((t) => (
          <li key={t.id}>
            <span>{t.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
